export default __webpack_public_path__ + "static/shrimps-527e559f6dd78dd4595798eb498826c7.jpeg";